












































































































































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';
import { default as VSelect } from 'vue-select';

// @ts-ignore
@Component({
  components: {
    ValidationProvider,
    VSelect,
  },
})
export default class FormInput extends Mixins(Input) {
  @Prop({ default: false }) autoFocus?: boolean;

  @Prop({ default: false }) hideLabel?: boolean;

  @Prop({ default: false }) disabled?: boolean;

  @Prop({ default: 'text' }) readonly type!: string;

  @Prop({ default: '' }) readonly value!: string | number;

  @Prop({ default: () => [] }) options!: any[];

  isFocussed: boolean = false;

  $refs!: Vue['$refs'] & {
    input: HTMLElement;
  };

  mounted() {
    if (this.autoFocus && this.$refs.input) {
      this.$refs.input.focus();
    }
  }

  @Emit('focus')
  private focus(e: Event) {
    this.isFocussed = true;
    return e;
  }

  @Emit('blur')
  private blur(e: Event) {
    this.isFocussed = false;
    return e;
  }

  @Emit('input')
  private updatePercent() {
    return this.localValue / 100;
  }

  @Watch('value', { immediate: true })
  private onValueChanged(val: string | number) {
    if (this.type === 'percent') {
      const precent: number = typeof val === 'string' ? parseFloat(val) : val;
      this.localValue = precent * 100;
    } else {
      this.localValue = val;
    }
  }
}
